import React, { useReducer, useEffect } from "react";
import {
    Table,
    TableHead,
    TableBody,
    Paper,
    Typography,
    CircularProgress,
    Toolbar as MuiToolbar,
} from "@mui/material";
import UserRow from "./UserRow";
import Pagination from "../components/Pagination";
import UsersTableHead from "../components/UsersTableHead";
import { ACTIONS, initialState, usersReducer } from "../reducers/usersReducer";
import { handleSortRequest } from "../utils/sortingUtils";
import api from "../services/api";

const columns = [
    { id: 'redirect', label: '', sortable: false },
    { id: "name", label: "Name", sortable: true },
    { id: "email", label: "Email", sortable: false },
    { id: "phone", label: "Phone", sortable: false },
    { id: "role", label: "Role", sortable: false },
    { id: 'comments', label: '', sortable: false },
    { id: 'imageUrl', label: '', sortable: false },
];

function Users({ data }) {

    const [state, dispatch] = useReducer(usersReducer, initialState);
    const { users, loading, error, order, orderBy, page, rowsPerPage, totalUsers } = state;
    const isSearchMode = !!data;
    const displayedUsers = isSearchMode ? data : users;

    useEffect(() => {
        if (isSearchMode) return;

        const fetchUsers = async () => {
            dispatch({ type: ACTIONS.FETCH_INIT });
            try {
                const token = localStorage.getItem("token");
                if (!token) {
                    throw new Error("No token found");
                }
                const response = await api.get("/users", {
                    headers: { Authorization: `Bearer ${token}` },
                    params: {
                        page: page + 1,
                        limit: rowsPerPage,
                        sortBy: orderBy,
                        order: order,
                    },
                });
                dispatch({
                    type: ACTIONS.FETCH_SUCCESS,
                    payload: { users: response.data.data, total: response.data.total },
                });
            } catch (err) {
                console.error("Error fetching users:", err);
                dispatch({ type: ACTIONS.FETCH_FAILURE, payload: "Failed to fetch users." });
            }
        };

        fetchUsers();
    }, [page, rowsPerPage, order, orderBy, isSearchMode]);

    const handleSort = handleSortRequest(orderBy, order, dispatch);

    const handleChangePage = (_, newPage) => dispatch({ type: ACTIONS.SET_PAGE, payload: newPage });

    const handleChangeRowsPerPage = (event) =>
        dispatch({ type: ACTIONS.SET_ROWS_PER_PAGE, payload: parseInt(event.target.value, 10) });

    return (
        <>
            <MuiToolbar />
            <Paper sx={{ padding: "1rem", width: "97%", margin: "1rem auto" }}>
                <Typography variant="h4" gutterBottom>
                    Users
                </Typography>
                {loading ? (
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <CircularProgress />
                    </div>
                ) : error ? (
                    <Typography variant="h6" color="error" align="center">
                        {error}
                    </Typography>
                ) : displayedUsers.length === 0 ? (
                    <Typography>No users found.</Typography>
                ) : (
                    <>
                        {!isSearchMode && (
                            <Pagination
                                count={totalUsers}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                        <Table>
                            <TableHead>
                                <UsersTableHead columns={columns} order={order} orderBy={orderBy} onSortRequest={handleSort} />
                            </TableHead>
                            <TableBody>{displayedUsers.map((user) => <UserRow key={user.id} user={user} users={displayedUsers} />)}</TableBody>
                        </Table>
                        {!isSearchMode && (
                            <Pagination
                                count={totalUsers}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </>
                )}
            </Paper>
        </>
    );
}

export default Users;